/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
var UserLevelUtil = require("clover/logic/userLevel/UserLevelUtil")
UserLevel = xClass("UserLevel", Event)
UserLevelEvent = table(
    [1, "StartLevel", "USERLEVELEVENT.STARTLEVEL"],
    [1, "EndLevel", "USERLEVELEVENT.ENDLEVEL"],
    [1, "WinLevel", "USERLEVELEVENT.WINLEVEL"],
    [1, "LoseLevel", "USERLEVELEVENT.LOSELEVEL"],
    [1, "ExitLevel", "USERLEVELEVENT.EXITLEVEL"]
)
var instance = null
UserLevel.getInstance = function () {
    if (!instance) {
        instance = UserLevel.new()
    }
    return instance
}
UserLevel.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.currentLevel = null
    self.levelTypeEnum = require("clover/logic/userLevel/UserLevelTypeEnum")
}
UserLevel.prototype.addLevelTypeEnum = function (levelType, levelTypeClass) {
    let self = this
    // body
    self.levelTypeEnum[levelType] = levelTypeClass
}
UserLevel.prototype.canStartLevel = function (levelId, itemList, extraData,notVague) {
    var self = this
    itemList = itemList || table()
    levelType = LevelType.getLevelTypeByLevelId(levelId)
    if (!levelType) {
        return [false, ZooErrorCode.UNDEFINED_LEVEL_TYPE]
    }
    if (extraData && extraData.contestUid) {
        return [true]
    }
    if (type(self.levelTypeEnum[levelType]) !== "nil") {
        // WARN: maybe multi result
        return self.levelTypeEnum[levelType].prototype.canStartLevel(levelId, itemList,notVague)
    } else {
        return [false, ZooErrorCode.UNDEFINED_LEVEL_TYPE]
    }
}
UserLevel.prototype.getConsumeEnergyByLevelId = function (levelId) {
    var self = this
    var levelType = LevelType.getLevelTypeByLevelId(levelId)
    if (!levelType) {
        return 0
    } else if (type(self.levelTypeEnum[levelType]) !== "nil") {
        // WARN: maybe multi result
        return self.levelTypeEnum[levelType].prototype.getConsumeEnergy(levelId)
    } else {
        return 0
    }
}
UserLevel.prototype.startLevel = function (levelId, itemList, successCallback, failCallback, cancelCallback, needMask = true, extraData, adPropIds, adStartPropIds) {
    var self = this
    var [loadId, listening] = [null, true]
    function removeAnim() {
        if (loadId) {
            LoadingPanelLogic.getInstance().remove(loadId)
        }
    }
    if (needMask) {
        loadId = LoadingPanelLogic.getInstance().add(null, function () {
            if (!listening) {
                return 
            }
            removeAnim()
            listening = false
            if (cancelCallback) {
                cancelCallback()
            }
        })
    }
    self.checkUseProp = false
    function onSuccess(event) {
        removeAnim()
        UserManager.getInstance().addTopLevelPlayNum(levelId)
        var levelType = LevelType.getLevelTypeByLevelId(levelId)
        UserManager.getInstance().getAndUpdateTimeProps()
        UserProp.getInstance().removeAllTempProps()
        self.dispatchEvent(table(
            [1, "name", UserLevelEvent.StartLevel],
            [1, "levelId", levelId],
            [1, "levelType", levelType],
            [1, "itemList", itemList],
            [1, "adPropIds", adPropIds]
        ))
        if (NetworkConfig.writeLocalDataStorage) {
            Localhost.getInstance().flushCurrentUserData()
        } else {
            cc.log("Did not write user data to the device.")
        }
        if (successCallback) {
            successCallback(event)
        }
        //检查消耗
        let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
        let passedTopLvl = UserManager.getInstance().getPassedTopLevel()
        if (LevelType.isMainLevel(levelId) && levelId >= topLevel && levelId > passedTopLvl) {
            self.checkUseProp = true
        } else if (LevelType.isMysteryIslandLevel(levelId)) {
            self.checkUseProp = true
        }
    }
    function onFail(event) {
        removeAnim()
        self.clearCurrentLevel()
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        removeAnim()
        self.clearCurrentLevel()
        if (cancelCallback) {
            cancelCallback()
        }
    }

    function startLevel() {
        var [success, errCode] = self.canStartLevel(levelId, itemList, extraData)
        //看广告开始不消耗精力
        if (!success && adStartPropIds && errCode === ZooErrorCode.ENERGY_NOT_ENOUGH){

        }else if (!success) {
            var param = table(
                [1, "levelId", levelId],
                [1, "errCode", errCode],
                [1, "now", Localhost.time()],
                [1, "updateTime", UserManager.getInstance().getUserRef().getUpdateTime()]
            )
            DCAssist.dcOnlineDebugInfo("userLevelCanStart", param)
            onFail(table([1, "data", errCode]))
            return 
        }
        var levelType = LevelType.getLevelTypeByLevelId(levelId)
        var currentLevel = self.levelTypeEnum[levelType].create(levelId, itemList)
        self.setCurrentLevel(currentLevel)
        self.currentLevel.startLevel(levelId, itemList, onSuccess, onFail, onCancel)
    }

    let last_score_info = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_PASS_LEVEL_INFO)
    if(last_score_info && last_score_info !== ""){
        self.uploadLastScore(startLevel, onFail, onCancel)
    }else{
        startLevel()
    }
}
UserLevel.prototype.uploadLastScore = function (callback, onFail, onCancel) {
    function lastLevelDataErrorLog(reason) {
        let uid = UserManager.getInstance().uid
        LogToLogCenter(new Error(`parse last level data error at userLevel, uid: ${uid}, lastRecord: ${JSON.stringify(last_score_info)}, reason: ${reason}`))
    }
    let last_score_info = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_PASS_LEVEL_INFO)
    let last_score_mem = UserManager.getInstance().lastLvlReplay
    if((last_score_info && last_score_info !== "") || last_score_mem){
        try {
            last_score_info = JSON.parse(last_score_info)
        } catch (error) {
            lastLevelDataErrorLog(error)
            if (last_score_mem){
                console.log("$$$$use las score mem")
                last_score_info = last_score_mem
            }else{
                cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
                last_score_info = null
                callback && callback()
                return       
            }
        }
        if(last_score_info && last_score_info.levelId && last_score_info.star && last_score_info.score && last_score_info.replay){
            function _onSuccess(evt) {
                cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
                UserManager.getInstance().lastLvlReplay = null
                let rewardList = evt && evt.data && evt.data.rewardItems || table()
                for (let index = 1, v = rewardList[index]; v; v = rewardList[++index]) {
                    UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.STAGE_REWARD)
                }
                callback && callback()
                let uid = UserManager.getInstance().uid
                LogToLogCenter(new Error(`update last score data success, uid: ${uid}, lastRecord: ${JSON.stringify(last_score_info)}`))
            }
            var http = PassLevelHttp.new(true)
            http.addEventListener(Events.kComplete, _onSuccess)
            http.addEventListener(Events.kError, (evt) => {
                if (evt && evt.data > 0) {
                    cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
                    UserManager.getInstance().lastLvlReplay = null
                }
                onFail && onFail()
            })
            http.addEventListener(Events.kCancel, () => {
                onCancel && onCancel()
            })
            http.load(
                last_score_info.levelId, 
                last_score_info.score, 
                last_score_info.star, null, null, 
                last_score_info.targetCount, null, null, null, 
                last_score_info.replay,
                // last_score_info.hasOwnProperty("refreshUseNum")? {refreshUseNum: last_score_info.refreshUseNum}: null
                last_score_info.extraData
            )
        }else {
            lastLevelDataErrorLog(`无效的 score 数据, last_score_info: ${!!last_score_info}, table: ${type(last_score_info) === "table"}, levelId, star, score, replay: [${last_score_info.levelId > 0}, ${last_score_info.star > 0}, ${last_score_info.score > 0}, ${!!last_score_info.replay}]`)
            cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
            UserManager.getInstance().lastLvlReplay = null
            callback && callback()
        }
    }else {
        callback && callback()
    }
}
UserLevel.prototype.canEndLevel = function (levelId, score, star, stageTime, coin, targetCount, opLog, costMove) {
    var self = this
    if (!self.currentLevel || self.currentLevel.levelId !== levelId) {
        DCAssist.dcOnlineDebugInfo("userLevelCanEnd", table(
            [1, "levelId", levelId],
            [1, "errCode", ZooErrorCode.LEVEL_ID_INVALID],
            [1, "currentLevel", tostring((self.currentLevel || table()).levelId)]
        ))
        return [false, ZooErrorCode.LEVEL_ID_INVALID]
    }
    return [true, 0]
}
// 结束关卡请求本身不存在无法结束关卡的状况 是关卡数据出问题
// TODO: 这个方法的实现好像有问题……？

let endLevelPoint = []
UserLevel.prototype.endLevel = function (levelId, score, star, stageTime, coin, targetCount, opLog, costMove, replay ,successCallback, failCallback, cancelCallback, otherData) {
    var self = this
    otherData = otherData || {}
    var [successCallback, failCallback, cancelCallback] = HookFuncsCalledOnce(successCallback, failCallback, cancelCallback)
    // step.150 新用户第一关首次通过并开始弹出“下一关”面板

    // 前5关完成打点
    let startStep = 150
    if (_G.kIsNewUser && levelId <= 5 && !endLevelPoint[levelId]) {
        endLevelPoint[levelId] = true
        // let currentStep = startStep + (levelId - 1) * 10
       // DCAssist.dcForGameLoading(currentStep, true);
    }
    DCAssist.dc4LevelUserOp150(levelId)
    
    let loadId = null
    function removeAnim() {
        if (loadId) {
            LoadingPanelLogic.getInstance().remove(loadId)
            loadId = null
        }
    }
    loadId = LoadingPanelLogic.getInstance().add(null, function () {
        removeAnim()
        if (cancelCallback) {
            cancelCallback()
        }
    })

    function update() {
        removeAnim()
        self.clearCurrentLevel()
        UserManager.getInstance().getAndUpdateTimeProps()
        UserProp.getInstance().removeAllTempProps()
    }
    function onSuccess(event) {
        self.dispatchEvent(table(
            [1, "name", UserLevelEvent.EndLevel],
            [1, "levelId", levelId],
            [1, "score", score],
            [1, "star", star],
            [1, "stageTime", stageTime],
            [1, "coin", coin],
            [1, "targetCount", targetCount],
            [1, "opLog", opLog],
            [1, "costMove", costMove]
        ))
        if (score === 0 && star === 0) {
            self.dispatchEvent(table(
                [1, "name", UserLevelEvent.ExitLevel],
                [1, "levelId", levelId],
                [1, "score", score],
                [1, "star", star],
                [1, "stageTime", stageTime],
                [1, "coin", coin],
                [1, "targetCount", targetCount],
                [1, "opLog", opLog],
                [1, "costMove", costMove]
            ))
        } else if (star === 0) {
            self.dispatchEvent(table(
                [1, "name", UserLevelEvent.LoseLevel],
                [1, "levelId", levelId],
                [1, "score", score],
                [1, "star", star],
                [1, "stageTime", stageTime],
                [1, "coin", coin],
                [1, "targetCount", targetCount],
                [1, "opLog", opLog],
                [1, "costMove", costMove]
            ))
        } else {
            if (self.checkUseProp) {
                // let userExtendRef = UserManager.getInstance().getUserExtendRef()
                UserManager.getInstance().tryAddNewLevelConsumeRecord(levelId)
            }
            UserManager.getInstance().cleanTopLevelPlayNum(levelId)
            self.dispatchEvent(table(
                [1, "name", UserLevelEvent.WinLevel],
                [1, "levelId", levelId],
                [1, "score", score],
                [1, "star", star],
                [1, "stageTime", stageTime],
                [1, "coin", coin],
                [1, "targetCount", targetCount],
                [1, "opLog", opLog],
                [1, "costMove", costMove]
            ))
        }
        update()

        // 微信好友排行数据
        if (META.platform == XcloverPlatform.wechatgame) {
            let kVDatas = []
            let rankInfo = {}
            let um = UserManager.getInstance()
            var user = um.getUserRef()
            rankInfo.yellowStar = user.getYellowStar()
            rankInfo.blueStar = user.getBlueStar()
            rankInfo.orangeStar = user.getOrangeStar()
            rankInfo.starUpdateTime = user.getStarUpdateTime()
            rankInfo.topLevelId = user.getTopLevelId()
            rankInfo.uid = user.uid
            let labelinfo = UserManager.getInstance().getUserShowRef().getNameLabelIdWithExpireTime()
            rankInfo.nameLabelId = labelinfo[0]
            rankInfo.nameLabelExpireTime = labelinfo[1]
            // 好友排行信息
            kVDatas.push({
                key: "rankInfo",
                value: JSON.stringify(rankInfo)
            })

            //微信小游戏排行榜信息(排行榜信息只能在第一层key，所以这里必须从rankInfo里拿出来)
            let topKey = window.qq? "qqgame": "wxgame"
            kVDatas.push({
                key: "toplevel",
                value: JSON.stringify({
                    [topKey]: {
                        "score": rankInfo.topLevelId,
                        "update_time": Localhost.timeInSec()
                    }
                })
            })
            
            if (mini.setUserCloudStorage) {
                mini.setUserCloudStorage({
                    KVDataList: kVDatas
                })
                cc.log("endLevel mini.setUserCloudStorage", kVDatas)
            } else {
                cc.log("endLevel setUserCloudStorage", kVDatas)
            }
        }

        if (NetworkConfig.writeLocalDataStorage) {
            Localhost.getInstance().flushCurrentUserData()
        } else {
            cc.log("Did not write user data to the device.")
        }
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        update()
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        update()
        if (cancelCallback) {
            cancelCallback()
        }
    }
    var [success, errCode] = self.canEndLevel(levelId, score, star, stageTime, coin, targetCount, opLog, costMove)
    if (!success) {
        onFail(table([1, "data", errCode]))
        return 
    }
    DCAssist.dc4LevelUserOp160(levelId)
    otherData.loadingPanelId = loadId
    self.currentLevel.endLevel(score, star, stageTime, coin, targetCount, opLog, costMove, replay, onSuccess, onFail, onCancel, otherData)
}
// 这里的程序是UserLevelTypeBase:endLevel_calcReward的复制，为了不破坏结构性所以复制了一份，没准后面会重构吧
UserLevel.prototype.calcPassLevelRewardItems = function (levelId, score, star) {
    var self = this
    var oldScore = UserScore.getInstance().getScore(levelId)
    var newScore = UserScore.getInstance().createScore(levelId, score, star)
    // WARN: maybe multi result
    return UserLevelUtil.calcPassLevelRewardItems(levelId, newScore, oldScore)
}
UserLevel.prototype.canUseProp = function (propId, num) {
    var self = this
    var level = self.getCurrentLevel()
    if (level) {
        var [success, errCode] = level.canUseProp(propId, num)
        if (!success) {
            return [success, errCode]
        }
    } else {
        return [false, ZooErrorCode.USE_PROP_RANGE_ERROR]
    }
    return [true]
}
UserLevel.prototype.getCurrentLevel = function () {
    var self = this
    return self.currentLevel
}
UserLevel.prototype.setCurrentLevel = function (currentLevel) {
    var self = this
    // body
    self.currentLevel = currentLevel
    self.isHaveEquityMonthTicketTag = false
}
UserLevel.prototype.clearCurrentLevel = function () {
    var self = this
    // body
    if (self.currentLevel) {
        self.currentLevel = null
    }

}
UserLevel.prototype.isHaveEquityMonthTicket = function () {
    return false
}